'use client';
import { RefObject } from 'react';
import { cn } from '@/app/lib';
import { VideoPlayer } from '../ui/VideoPlayer';
import { Thumbnail } from '../ui/Thumbnail';
import { PlayButton } from '../ui/PlayButton';
import { Thumbnail as ThumbnailType } from '@workspace/interfaces';

interface VideoWithoutTextProps {
  wrapperRef: (node?: Element | null) => void;
  playerContainerRef: RefObject<HTMLDivElement | null>;
  thumbnail?: ThumbnailType;
  isPlaying: boolean;
  onPlay: () => void;
  onPause: () => void;
  wrapperClassName?: string;
  aspectRatio?: string;
}

export function VideoWithoutText({
  wrapperRef,
  playerContainerRef,
  thumbnail,
  isPlaying,
  onPlay,
  onPause,
  wrapperClassName,
  aspectRatio,
}: VideoWithoutTextProps) {
  return (
    <div
      className={cn('relative w-full overflow-hidden', wrapperClassName)}
      ref={wrapperRef}
      style={aspectRatio ? { aspectRatio } : undefined}
    >
      {!isPlaying && thumbnail && (
        <Thumbnail thumbnail={thumbnail} onPlay={onPlay} className="absolute inset-0 w-full h-full object-cover z-20" />
      )}
      <VideoPlayer containerRef={playerContainerRef} onToggle={isPlaying ? onPause : onPlay} />
      {!isPlaying && (
        <>
          <div className="absolute w-full h-full top-0 left-0 z-5 pointer-events-none" />
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 cursor-pointer text-white pointer-events-auto">
            <PlayButton onPlay={onPlay} variant="white" />
          </div>
        </>
      )}
    </div>
  );
}
